<template>
  <component :is="list.skipCardLayout?'div':'md-card'">
    <md-card-header class="md-card-header-icon md-card-header-green list-header" :class="list.hideListHeader? 'list-header-hidden' : ''">
      <template v-if="!list.hideListHeader">
        <div class="card-icon">
          <md-icon>{{ list.pageIcon }}</md-icon>
        </div>
        <h4 class="title">{{ list.pageTitle }}</h4>
      </template>
      <button v-if="!list.skipCardLayout && !list.hideNewRecordButton" v-on:click="newRecord()" class="md-button md-primary md-sm" style="float:right">Add<md-icon class="md-small">control_point</md-icon></button>
      <md-button id="messageListRefresh" class="md-just-icon md-simple" @click="refresh()"><md-icon>refresh</md-icon></md-button>
    </md-card-header>

    <component
      v-if="onlyShowListIf === null || onlyShowListIf"
      :is="list.skipCardLayout?'div':'md-card-content'">

      <md-snackbar :md-position="'center'" :md-duration="4000" :md-active.sync="searchError" md-persistent>
        <span>{{searchErrorMessage}}</span><!--<md-button class="md-primary" @click="showSnackbar = false">Retry</md-button>-->
      </md-snackbar>

      <!-- Create Custom Tabs -->
      <md-tabs class="customTaskDialogTabs">
        <md-tab class="customTaskDialogTabs__tab" id="tab-home" md-label="From Template">
          <div class="dynamicList-loading"
            v-show="isPromisePending">
            <md-progress-spinner :md-diameter="40" :md-stroke="4" md-mode="indeterminate" />
          </div>
          <md-table
            :value="queriedData"
            :md-sort.sync="currentSort"
            :md-sort-order.sync="currentSortDir"
            :md-sort-fn="customSort"
            :searchQuery="searchQuery"
            class="paginated-table table-striped table-hover"
          >
            <md-table-toolbar class="hide-overflow">
              <md-field class="_uiKitInput">
                <label>Search</label>
                <md-input
                  type="search"
                  class="mb-3"
                  clearable
                  style="width: 200px"
                  placeholder="Search records"
                  v-model="searchQuery"
                  ref="searchQuery"
                >
                </md-input>
              </md-field>

              <md-field class="_uiKitInput">
                <label for="pages">Per page</label>
                <md-select v-model="currentPerPage" :key="'perPage' + activeDataName" name="pages">
                  <md-option
                    v-for="item in list.perPageOptions"
                    :key="item"
                    :label="item"
                    :value="item"
                  >
                    {{ item }}
                  </md-option>
                </md-select>
              </md-field>
            </md-table-toolbar>

            <md-table-row slot="md-table-row" slot-scope="{ item }">
              <template v-for="(column, name) in list.columns">
                <md-table-cell :key="name" :md-label="column.label" :md-sort-by="column.sortable? name : null">{{ `${getColumnDisplayValue(column, item, name)}` }}</md-table-cell>
              </template>

              <md-table-cell md-label="Actions">
                <template v-if="list.itemActions">
                  <template v-for="(action) in list.itemActions">
                    <md-button
                      :key="action.icon"
                      :class="item.added? action.classAdded : action.class"
                      @click="callItemAction(action.click, item)"
                    >
                      <md-icon>{{item.added? action.iconAdded : action.icon}}</md-icon>
                    </md-button>
                  </template>
                </template>
              </md-table-cell>
            </md-table-row>
          </md-table>
        </md-tab>

        <md-tab class="customTaskDialogTabs__tab" id="tab-pages" md-label="New Template">
          <CustomCaseTemplateTaskForm
            :update="updateFormKey"
            :form="form"
            :$v="$v"
            :formConfig="formConfig"
            :recordData="recordDataKey"
            :groupIndex="relateRecordInput.group"
            :orderIndex="relateRecordInput.order"
            @dialogChange="onDialogChange"
            @taskCreated="onTaskCreated"
          ></CustomCaseTemplateTaskForm>
        </md-tab>
      </md-tabs>
    </component>

    <md-card-actions md-alignment="space-between">
      <div class="">
        <p v-if="queriedData.length" class="card-category number">
          Showing {{ from + 1 }} to {{ from + queriedData.length }} of {{ activeData.items.length }} results fetched
        </p>
        <p v-else class="card-category">
          0 results
        </p>
      </div>
      <pagination
        v-show="queriedData.length"
        class="pagination-no-border pagination-success"
        v-model="activeData.curPage"
        :per-page="currentPerPage"
        :total="totalPages"
        :pageCount="totalPages"
        :nextToken="activeData.nextToken"
        @loadMore="loadMore"
      >
      </pagination>
    </md-card-actions>
  </component>
</template>

<script>
  import RecordList from '@/mixins/RecordList';
  import CustomCaseTemplateTaskForm from "@/components/DynamicForm/CustomCaseTemplateTaskForm";
  import { required, numeric, minLength } from "vuelidate/lib/validators";
  import Amplify, { API, graphqlOperation } from 'aws-amplify';
  import * as queries from '@/graphql/queries';
  import * as queries_custom from '@/graphql/queries_custom';
  export default {
    mixins: [RecordList],
    components: {
      CustomCaseTemplateTaskForm
    },
    data() {
      return {
        reservedNameValidatorTimeoutId: null,
        isFirstTimeReservedNameCheck: true,
        formConfig: {
          hasUpdatedBy: true,
          updatedByTaskFieldName: 'taskUpdatedById',
          updatedByTaskStepFieldName: 'taskStepUpdatedById',
          isTemplateActive: true,
          responseFieldName: "getTask",
          actions: {
            save: "createTask",
            view: "getTask",
            edit: "editTask",
            new: "newTask",
            update: "updateTask",
            delete: "deleteTask"
          },
          slots: {
            basic: { label: "Basic Information", icon: "work", layout: {"x":0,"y":0,"w":6,"h":18,"i":"0"} }
          },
          listPath: "/tasks",
          headerIcon: "assignment",
          objectName: "Task",
          objectNamePlural: "Tasks",
          editMode: false,
          pageMode: 'new', // can be one of ['new', 'view' 'edit']
          fields: {
            id: { label: "ID", type: "id", slot: "basic" },
            subject: { label: "Subject", type: "text", slot: "basic", uniqueErrorMessage: 'This is reserved name' },
            type: {
              label: "Type",
              type: "select",
              slot: "basic",
              options: [
                { name: "Application", id: "Application" },
                { name: "Call", id: "Call" },
                { name: "FollowUp", id: "FollowUp" },
                { name: "Meeting", id: "Meeting" },
                { name: "ReviewIncomingMessage", id: "ReviewIncomingMessage" },
                { name: "Other", id: "Other" }
              ]
            },
            priority: {
              label: "Priority",
              type: "select",
              slot: "basic",
              options: [
                { name: "High", id: "High" },
                { name: "Low", id: "Low" },
                { name: "Normal", id: "Normal" },
                { name: "Rush", id: "Rush" },
                { name: "Critical", id: "Critical" }
              ]
            },
            status: {
              label: "Status",
              type: "select",
              slot: "basic",
              options: [
                { name: "Open", id: "Open" },
                { name: "WaitingOnCustomer", id: "WaitingOnCustomer" },
                { name: "OnHold", id: "OnHold" },
                { name: "Completed", id: "Completed" },
                { name: "Closed By Workflow", id: "Closed_By_Workflow" }
              ],
              preventOptSelect:'Closed_By_Workflow'
            },
            taskUserId: { label: "Assignee", type: "autocomplete", slot: 'basic',
              data: [],
              displayFieldOne: 'given_name', 
              displayFieldTwo: 'family_name',
              searchTerm: "",
              options: [],
              linkBase: '#/users/',
              setVal: (val) => {
                this.$v.form.taskUserId.$model = val;
              },
              select: (c) => {(($this) => {
                $this.setVal(c.id);
                $this.searchTerm = c.given_name + ' ' + c.family_name;
              })(this.formConfig.fields.taskUserId)},
              hasValidation: true,
              isLazyLoadEnabled: true,
              lazyLoadListQueryId: 'searchUsers',
              lazyLoadResponseFieldName: 'searchUsers',
              lazyLoadSearchableFields: ['given_name', 'family_name'],
              // change: (search) => {(($this) => {
              //   const data = $this.data;
              //   $this.options = new Promise(resolve => {
              //     window.setTimeout(() => {
              //       if (!search) {
              //         $this.setVal("");
              //         resolve(data)
              //       } else {
              //         const term = search.toLowerCase();
              //         let termGivenName = term.split(' ')[0];
              //         let termFamilyName = term.split(' ')[1];
                      
              //         let resultGivenName = data.filter(({ given_name }) => given_name.toLowerCase() === termGivenName);
              //         let resultFamilyName = data.filter(({ family_name }) => family_name.toLowerCase() === termFamilyName);
              //         if ((!resultGivenName.length) || (!resultFamilyName.length)) {  
              //           $this.setVal("");
              //         }
              //         resolve(data.filter(({ given_name, family_name }) => (given_name + ' ' + family_name).toLowerCase().includes(term)));
              //       }
              //     }, 100)
              //   })
              // })(this.formConfig.fields.taskUserId)}
            },
            isCompleteInOrder: {label: 'Complete In Order', type: 'switch', slot: 'basic' },
          },
          editTitleField: "name",
        },
        form: {
          id: "",
          subject: "",
          type: "",
          priority: "",
          status: "",
          taskUserId: "",
          isCompleteInOrder: false,
        },
        recordDataKey: {},
      };
    },
    validations() {
      return {
        form: {
          id: {},
          subject: { required, minLength: minLength(3),
              async isUnique(value) {
                if (value.trim().length < 3) {
                  return true;
                }
                const timeoutInterval = this.isFirstTimeReservedNameCheck ? 0 : 3000;
                this.isFirstTimeReservedNameCheck = false;
                clearTimeout(this.reservedNameValidatorTimeoutId);
                return new Promise(async (resolve, reject) => {
                  this.reservedNameValidatorTimeoutId = setTimeout(async () => {
                    const valueTrimmed = value.trim();
                    let params = {limit:999};
                    params.filter = {esQuery: JSON.stringify({"match": {"hasWorkflow": true }})};                    
                    params.limit = 999;
                    const query = queries_custom['searchTasksSteps'];
                    await API.graphql(graphqlOperation(query, params))
                      .then(result => {
                        if (
                          result.data && 
                          result.data.searchTasks && 
                          result.data.searchTasks.items
                        ) {
                          const index = result.data.searchTasks.items.findIndex(_item => {
                            return _item.subject.toLowerCase() == valueTrimmed.toLowerCase();
                          });
                          if (-1 === index) {
                            return resolve(true);
                          }
                          return reject(false);
                        }
                        reject(false);
                      })
                      .catch(err => {
                        if (
                          err &&
                          err.errors &&
                          err.errors[0].errorType &&
                          'Elasticsearch:UserIllegalArgumentException' == err.errors[0].errorType
                        ) {
                          resolve(true);
                        }
                        reject(false);
                      });
                  }, timeoutInterval);
                });
              }                            
          },
          type: {},
          priority: {},
          status: {},
          taskUserId: {
            isValid: this.isTaskUserIdValid,
          },
          isCompleteInOrder: {},
        }
      };
    },
    watch: {
      '$route.params': function () {
        if(this.$route.query.q)
          this.$refs["searchQuery"].value = this.$route.query.q
      }
    },
    created() {
      if(this.$route.query.q)
         this.searchQuery = this.$route.query.q
    },
    methods: {
      onTaskCreated(task) {
        this.$emit('taskCreated', task);
      },
      callItemAction(funcName, item) {
        this.$emit(funcName, item);
      },
      updateFormKey() {

      },
      onDialogChange(value) {
        this.$emit("dialogChange", value);
      },
      setCustomAutoCompleteFields(data) {
        if (typeof data === 'undefined') return;
        
        (($this) => {
          // $this.data = data.searchUsers.items;
          if (this.recordData && this.recordData.user) {
            $this.searchTerm = this.recordData.user.given_name + ' ' + this.recordData.user.family_name;
            this.form.taskUserId = this.recordData.user.id;
          } else {
            if (this.$route.query.taskUserId) {
              this.$v.form.taskUserId.$model = this.$route.query.taskUserId;
              /** try to find the User name */
              let matchingIndex = $this.data.findIndex(
                item => item.id === this.form.taskUserId
              );
              if (matchingIndex >= 0) {
                $this.searchTerm = $this.data[matchingIndex].given_name;
              }
            }
          }
        })(this.formConfig.fields.taskUserId);
        
      },
      async searchUsers () {
        let operation = [];
        operation = graphqlOperation(queries['searchUsers'],{limit:999});
        const result = await API.graphql(operation);
        this.setCustomAutoCompleteFields(result.data);
      },
      /**
       * Validate task user selection
       * @param {String} value the selected user ID
       * @returns {Promise}
       */
      async isTaskUserIdValid(value) {
        // normalized value
        const valueNormalized = value.toString().trim();
        
        // current field
        const field = this.formConfig.fields.taskUserId;
        
        // value is empty and there is no search term
        if (!valueNormalized && !field.searchTerm) {
            return true;
        }
        
        // clear existing timeout
        clearTimeout(field.timeoutId);
        
        // query name
        const queryName = 'getUser';
        
        // run new validation
        return new Promise(async (resolve, reject) => {
          field.timeoutId = setTimeout(() => {
            API.graphql(graphqlOperation(queries[queryName], { id: valueNormalized }))
              .then(res => {
                const data = res.data[queryName];
                const name = `${data.given_name} ${data.family_name}`;
                if (name === field.searchTerm) {
                  return resolve(true);
                }
                return reject(false);
              })
              .catch(err => {
                return reject(false);
              })
          }, 500);
        });
      },
    },
    mounted() {
      this.searchUsers();
    }
  };
</script>

<style lang="css" scoped>
  .md-card .md-card-actions{
    border: 0;
    margin-left: 20px;
    margin-right: 20px;
  }
  .md-card-header.list-header.list-header-hidden {
    padding-top: 12px;
  }
  .dynamicList-loading {
    position: absolute;
    top: 20px;
    left: 50%;
    transform:translateX(-50%);
    bottom: auto;
    right: auto;
    display: block;
  }
</style>
